import { USER_TOKEN, URL_BASE } from "./constants";
import { Store } from "../redux/store";
import { showWarning, showDefault } from "../redux/actions/snackbarActions";
import { post, handleErrors } from "./requests";
import { loginUser, logout as logoutUser } from "../redux/actions/authActions";

async function hasLoggedUser() {
    const states = Store.getState();
    const isLoggedUser = states.authState.isAuthenticated;

    if (isLoggedUser) {
        return true;
    }

    if (window.sessionStorage.getItem(USER_TOKEN) !== null) {
        const token = window.sessionStorage.getItem(USER_TOKEN);
        Store.dispatch(loginUser(token));
        return true;
    }

    if (window.localStorage.getItem(USER_TOKEN) !== null) {
        const token = window.localStorage.getItem(USER_TOKEN);
        Store.dispatch(loginUser(token));
        return true;
    }

    return false;
}

async function login(email, password, keepSession) {
    if (!email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) {
        Store.dispatch(showWarning("E-mail is empty or invalid."));
        return;
    }

    if (!password || password === "") {
        Store.dispatch(showWarning("Password is empty."));
        return;
    }

    const formData = new FormData();
    formData.append('email', email);
    formData.append('password', password);

    const payload = await post(`${URL_BASE}/account/login/admin`, formData, null,
        (error) => {
            const { status, data } = error;
            Store.dispatch(showWarning("Failed to login"));
            handleErrors(status, data);
        });

    if (payload.success) {  

        Store.dispatch(loginUser(payload.data));

        if (keepSession) {
            window.localStorage.setItem(USER_TOKEN, payload.data);
        } else {
            window.sessionStorage.setItem(USER_TOKEN, payload.data);
        }

    } else {
        Store.dispatch(showDefault("E-mail or password isn't correct"));
    }
}

async function logout() {    
    window.localStorage.removeItem(USER_TOKEN);
    window.sessionStorage.removeItem(USER_TOKEN);
    Store.dispatch(logoutUser());
}

export default {
    login,
    hasLoggedUser,
    logout
}